module.exports = __webpack_public_path__ + "img/finance_10.a13905d9.png";